import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
interface CTAButtonProps {
  text?: string;
  subtext?: string;
  className?: string;
  fullWidth?: boolean;
}
export function CTAButton({
  text = '👉 SÍ, QUIERO HACER MI RESET AHORA',
  subtext,
  className = '',
  fullWidth = false
}: CTAButtonProps) {
  const checkoutUrl = 'https://pagos.fegion.online/cart/45638802243723:1';
  return <a href={checkoutUrl} className={`
        group relative inline-flex flex-col items-center justify-center 
        bg-green-600 hover:bg-green-500 text-white 
        border-b-4 border-green-800 active:border-b-0 active:translate-y-1
        px-8 py-4 rounded-lg shadow-xl transition-all duration-200
        ${fullWidth ? 'w-full' : 'w-auto'}
        ${className}
      `} data-id="element-7">
      <span className="flex items-center gap-2 text-xl md:text-2xl font-bold uppercase tracking-wide text-center" data-id="element-8">
        {text}
        <ArrowRightIcon className="w-6 h-6 animate-pulse" data-id="element-9" />
      </span>
      {subtext && <span className="text-sm md:text-base font-medium opacity-90 mt-1" data-id="element-10">
          {subtext}
        </span>}
    </a>;
}